import React, { useEffect, useState } from "react";
import "../dashboard.scss";
import Select from "react-select";
import { vehroutelist, vehtypelist, vehtriplist } from "../../../services/master";
import moment from "moment";
import { academylist, createvehicle, driverlist, vehicledetail } from "../../../services/admin";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
export default function Addvehicle() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [vehno, setVehno] = useState("");
  const [regno, setRegno] = useState("");
  const [driverid, setDriverid] = useState("");
  const [dlist, setDriverlist] = useState([]);
  const [rcnum, setRcnum] = useState("");
  const [chasisnum, setChasisnum] = useState("");
  const [regdate, setRegDate] = useState("")
  const [rendate, setRenDate] = useState("")
  const [tsdate, setTSDate] = useState("")
  const [trdate, setTRDate] = useState("")
  const [vtype, setVtype] = useState("");
  const [vtlist, setVtlist] = useState([]);
  const [vrouteIds, setVrouteIds] = useState([]); // selected route ids (multi)
  const [vrlist, setVrlist] = useState([]);
  const [vtripIds, setVtripIds] = useState([]); // selected trip ids (multi)
  const [trlist, setTrlist] = useState([]);
  const [certnum, setCertnum] = useState("");
  const [psdate, setPSDate] = useState("");
  const [prdate, setPRendate] = useState("");
  const [insnum, setInsnum] = useState("")
  const [isdate, setISDate] = useState("");
  const [irendate, setIRenDate] = useState("");

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const location = useLocation();
  const [urllink, setUrllink] = useState("");

  useEffect(() => {

    const path = location.pathname.split("/")[2];
    setUrllink(path);
    if (path !== "vehicledetail") {
      setRegDate(moment(new Date()).format("YYYY-MM-DD"));
      setRenDate(moment(new Date()).format("YYYY-MM-DD"));
      setTSDate(moment(new Date()).format("YYYY-MM-DD"));
      setTRDate(moment(new Date()).format("YYYY-MM-DD"));
      setPSDate(moment(new Date()).format("YYYY-MM-DD"));
      setPRendate(moment(new Date()).format("YYYY-MM-DD"));
      setISDate(moment(new Date()).format("YYYY-MM-DD"));
      setIRenDate(moment(new Date()).format("YYYY-MM-DD"));
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);

                }
              }

            }
          }
        });
      }
    } else {
      vehicledetail(id).then((res) => {
        if (res.status === true) {
          setVehno(res.data.details.vehicle_no);
          setRegno(res.data.details.reg_no);
          setRcnum(res.data.details.rc_no);
          setChasisnum(res.data.details.chasis_no);
          setCertnum(res.data.details.certificate_no);
          setInsnum(res.data.details.insurance_no);
          if (res.data.details.vehicle_type !== null) {
            setVtype(res.data.details.vehicle_type);
          }
          if (res.data.details.vehicle_route !== null && res.data.details.vehicle_route !== "") {
            setVrouteIds(String(res.data.details.vehicle_route).split(",").map((v) => v.trim()).filter((v) => v !== ""));
          }
          if (res.data.details.vehicle_trip !== null && res.data.details.vehicle_trip !== undefined && res.data.details.vehicle_trip !== "") {
            setVtripIds(String(res.data.details.vehicle_trip).split(",").map((v) => v.trim()).filter((v) => v !== ""));
          }

          if (res.data.details.reg_date !== null) {
            setRegDate(moment(res.data.details.reg_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.reg_renewal_date !== null) {
            setRenDate(moment(res.data.details.reg_renewal_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.tax_start_date !== null) {
            setTSDate(moment(res.data.details.tax_start_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.tax_renewal_date !== null) {
            setTRDate(moment(res.data.details.tax_renewal_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.pos_start_date !== null) {
            setPSDate(moment(res.data.details.pos_start_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.pos_renewal_date !== null) {
            setPRendate(moment(res.data.details.pos_renewal_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.ins_start_date !== null) {
            setISDate(moment(res.data.details.ins_start_date).format("YYYY-MM-DD"));
          }
          if (res.data.details.ins_renewal_date !== null) {
            setIRenDate(moment(res.data.details.ins_renewal_date).format("YYYY-MM-DD"));
          }
          const temp = new FormData();
          temp.append("academy_id", res.data.details.academy_id);
          driverlist(temp).then((res1) => {
            if (res1.status === true) {
              let arr = [];
              if (res1.data.details.length > 0) {
                for (let i = 0; i < res1.data.details.length; i++) {
                  if (res1.data.details[i].id === res.data.details.driver_id) {
                    arr.push({
                      value: res1.data.details[i].id,
                      label:
                        res1.data.details[i].worker_name + " - " + res1.data.details[i].employee_id,
                    });
                  }

                }
                setDriverid(arr[0]);
              }
            }
          });

          academylist().then((res1) => {
            if (res1.status === true) {
              let arr = [];
              if (res1.data.details.length > 0) {
                for (let i = 0; i < res1.data.details.length; i++) {
                  if (res1.data.details[i].id === res.data.details.academy_id) {
                    arr.push({
                      value: res1.data.details[i].id,
                      label:
                        res1.data.details[i].name + " - " + res1.data.details[i].code,
                    });
                  }

                }
                setAcaID(arr[0]);
              }
            }
          });
        }
      })
    }

    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setAList(arr);
            listall(arr[0])
          }
        }
      });
    } else {
      listall("")
    }



  }, [location.pathname])

  function listall(aid) {
    setVtlist([]);
    setVrlist([]);
    setTrlist([]);
    setDriverlist([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    vehtypelist(temp).then((res) => {
      if (res.status === true) {
        // setVtlist(res.data);
        const sdata=res.data.filter((item) => item.active == 1);
        setVtlist(sdata);
      }
    });

    vehroutelist(temp).then((res) => {
      if (res.status === true) {
        setVrlist(res.data);
      }
    });

    vehtriplist(temp).then((res) => {
      if (res.status === true) {
        setTrlist(res.data);
      }
    });

    driverlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].worker_name + " - " + res.data.details[i].employee_id + " (" + res.data.details[i].username + ")",
            });
          }
          setDriverlist(arr);
        }
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);
    } else {
      setAcaID("");
      listall("");
    }
  }

  function handleDriver(e) {
    if (e !== null) {
      setDriverid(e);
    } else {
      setDriverid("");
    }
  }

  const [tsubmit, setTSubmit] = useState(false);
  function transportadd(e) {
    e.preventDefault();
    setTSubmit(true);
    if (vehno !== "" && regdate !== "" && driverid !== "" && rcnum !== "" && chasisnum !== "" && certnum !== "" && insnum !== "") {
      setTSubmit(false);
      setLoading(true);
      const temp = new FormData();
      temp.append("vehicle_no", vehno);
      temp.append("reg_no", regno);
      temp.append("driver_id", driverid.value);
      temp.append("rc_no", rcnum);
      temp.append("chasis_no", chasisnum);
      temp.append("reg_date", regdate);
      temp.append("reg_renewal_date", rendate);
      temp.append("tax_start_date", tsdate);
      temp.append("tax_renewal_date", trdate);
      temp.append("vehicle_type", vtype);
      temp.append("vehicle_route", vrouteIds.join(","));
      temp.append("vehicle_trip", vtripIds.join(","));
      temp.append("certificate_no", certnum);
      temp.append("pos_start_date", psdate);
      temp.append("pos_renewal_date", prdate);
      temp.append("insurance_no", insnum);
      temp.append("ins_start_date", isdate);
      temp.append("ins_renewal_date", irendate);
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy_id", acaid.value);
      }
      if (urllink !== "addvehicle") {
        temp.append("id", id);
      }
      createvehicle(temp).then((res) => {
        if (res.status === true) {
          setLoading(false);
          navigate("/transport/vehiclelist");
          toast.success(res.message);
        } else {
          setLoading(false);
          toast.error(res.message);
        }
      });

    }
  }
  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        {urllink === "addvehicle" && <h2 className="main-content-title tx-24 mg-b-5">Add Vehicle</h2>}
        {urllink === "vehicledetail" && <h2 className="main-content-title tx-24 mg-b-5">Vehicle Detail</h2>}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Transport Module</a>
          </li>
          {urllink === "addvehicle" && <li className="breadcrumb-item active" aria-current="page">Add Vehicle</li>}
          {urllink === "vehicledetail" && <li className="breadcrumb-item active" aria-current="page">Vehicle Detail</li>}

        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading &&
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Add Vehicle And Registration Detail
                    </h2>{" "}
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={alist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {tsubmit && acaid === "" &&
                              <span className="text-danger">Please Select Academy</span>
                            }
                          </div>
                        </div>
                      )}
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            School Allocated Vehicle Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Vehicle Number"
                            onChange={(e) => setVehno(e.target.value)}
                            value={vehno}
                          />
                          {tsubmit && vehno === "" &&
                            <span className="text-danger">Please Enter Vehicle Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Vehicle Registration Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Vehicle Registration Number"
                            onChange={(e) => setRegno(e.target.value)}
                            value={regno}
                          />
                          {tsubmit && regno === "" &&
                            <span className="text-danger">Please Enter Vehicle Registration Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Allocated Driver {" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Driver"
                            value={driverid}
                            options={dlist}
                            onChange={handleDriver}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {tsubmit && driverid === "" &&
                            <span className="text-danger">Please Select Driver ID</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            RC Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter RC Number "
                            onChange={(e) => setRcnum(e.target.value)}
                            value={rcnum}
                          />
                          {tsubmit && rcnum === "" &&
                            <span className="text-danger">Please Enter RC Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Chasis Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Chasis Number"
                            onChange={(e) => setChasisnum(e.target.value)}
                            value={chasisnum}
                          />
                          {tsubmit && chasisnum === "" &&
                            <span className="text-danger">Please Enter Chasis Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Registration Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setRegDate(e.target.value)} value={regdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Registration Renewal Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setRenDate(e.target.value)} value={rendate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Tax Start Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setTSDate(e.target.value)} value={tsdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Tax Renewal Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setTRDate(e.target.value)} value={trdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Vehicle Type</label>
                          <select className="default-select form-control wide" onChange={(e) => setVtype(e.target.value)} value={vtype}>
                            <option value="" disabled>
                              Select Vehicle Type
                            </option>
                            {vtlist.map((item, index) => {
                              return (
                                <option key={index} value={item.id}>
                                  {item.vehtype_name}
                                </option>
                              );
                            })

                            }
                          </select>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Route Name</label>
                          <Select
                            isMulti
                            className="default-select"
                            classNamePrefix="select"
                            placeholder="Select Route Name"
                            options={vrlist.map((item) => ({ value: String(item.id), label: item.vehroute_name }))}
                            value={vrlist
                              .filter((item) => vrouteIds.includes(String(item.id)))
                              .map((item) => ({ value: String(item.id), label: item.vehroute_name }))}
                            onChange={(selected) =>
                              setVrouteIds((selected || []).map((o) => String(o.value)))
                            }
                            isSearchable={true}
                            isClearable
                          />
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Trip</label>
                          <Select
                            isMulti
                            className="default-select"
                            classNamePrefix="select"
                            placeholder="Select Trip"
                            options={trlist.map((item) => ({ value: String(item.id), label: item.vehtrip_name }))}
                            value={trlist
                              .filter((item) => vtripIds.includes(String(item.id)))
                              .map((item) => ({ value: String(item.id), label: item.vehtrip_name }))}
                            onChange={(selected) =>
                              setVtripIds((selected || []).map((o) => String(o.value)))
                            }
                            isSearchable={true}
                            isClearable
                          />
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Vehicle POC and Insurance Detail
                    </h2>{" "}
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Pollution Certification Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Pollution Certification Number"
                            onChange={(e) => setCertnum(e.target.value)}
                            value={certnum}
                          />
                          {tsubmit && certnum === "" &&
                            <span className="text-danger">Please Enter Pollution Certification Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            POC Start Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setPSDate(e.target.value)} value={psdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            POC Renewal Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setPRendate(e.target.value)} value={prdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Insurance Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Insurance Number"
                            onChange={(e) => setInsnum(e.target.value)}
                            value={insnum}
                          />
                          {tsubmit && insnum === "" &&
                            <span className="text-danger">Please Enter Insurance Number</span>
                          }
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Insurance Start Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setISDate(e.target.value)} value={isdate} />
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Insurance Renewal Date
                          </label>
                          <div className="input-group">
                            <input className="form-control" type="date" onChange={(e) => setIRenDate(e.target.value)} value={irendate} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="res-right mt-4 mb-4 me-4">
              {urllink === "addvehicle" &&
                <button className="btn btn-success" onClick={transportadd}>Submit</button>

              }
              {urllink === "vehicledetail" &&
                <>
                  <button className="btn btn-success me-2" onClick={transportadd}>Update</button>
                  <button className="btn btn-secondary" onClick={() => { navigate("/transport/vehiclelist") }}>Back</button>

                </>
              }
            </div>
          </div>
        </div>
      }


    </div>
  );
}
